// extracted by mini-css-extract-plugin
export var button = "formSection-module--button--6a12a";
export var checkbox = "formSection-module--checkbox--2cb66";
export var checkboxW = "formSection-module--checkboxW--24eb1";
export var labelW = "formSection-module--labelW--08dc5";
export var name = "formSection-module--name--02b7e";
export var optin = "formSection-module--optin--13ae7";
export var popUp = "formSection-module--popUp--07e5a";
export var wrapper = "formSection-module--wrapper--c326d";
export var wrapperCheckbox = "formSection-module--wrapperCheckbox--11c6e";